// extracted by mini-css-extract-plugin
export default {"form":"form___f7RMG","control":"control___cw8Fo"};